(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    function lightboxFor(el) {
      var root = el.closest('[data-lbx-root]');
      return root ? root.querySelector('[data-lbx]') : null;
    }
    function open(dlg, src, caption) {
      var img = dlg.querySelector('[data-lbx-img]');
      var cap = dlg.querySelector('[data-lbx-cap]');
      img.src = src;
      img.alt = caption || '';
      if (cap) cap.textContent = caption || '';
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
    }
    function close(dlg) {
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      document.documentElement.style.overflow = '';
      var img = dlg.querySelector('[data-lbx-img]');
      if (img) img.src = '';
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var trigger = e.target.closest('[data-lbx-open]');
      if (trigger) {
        var dlg = lightboxFor(trigger);
        if (!dlg) return;
        e.preventDefault();
        open(dlg, trigger.getAttribute('data-lbx-open'), trigger.getAttribute('data-lbx-caption'));
        return;
      }
      var closeBtn = e.target.closest('[data-lbx-close]');
      if (closeBtn) { e.stopPropagation(); close(closeBtn.closest('[data-lbx]')); return; }
      // Click on the backdrop (outside the image/caption) closes too.
      var dlgHit = e.target.closest('[data-lbx]');
      if (dlgHit && dlgHit.open) {
        var inner = dlgHit.querySelector('[data-lbx-inner]');
        if (e.target === dlgHit || (inner && !inner.contains(e.target))) close(dlgHit);
      }
    });
    // Escape: native dialogs fire `cancel`; the open-attribute fallback needs keydown.
    document.addEventListener('cancel', function (e) {
      if (e.target.matches && e.target.matches('[data-lbx]')) { e.preventDefault(); close(e.target); }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-lbx][open]').forEach(close);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
